import React, { useEffect, useState } from 'react';
import { useGesture } from '../context/GestureContext';
import './GestureIndicator.css';

const GestureIndicator = ({ gesture, enabled }) => {
  const [show, setShow] = useState(false);
  const { cardNavActive } = useGesture();

  useEffect(() => {
    if (gesture && enabled) {
      setShow(true);
      const timer = setTimeout(() => setShow(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [gesture, enabled]);

  const getGestureLabel = (gesture) => {
    const labels = {
      'swipe_left': cardNavActive ? '👉 Focus Next' : 'Next Page →',
      'swipe_right': cardNavActive ? '👈 Focus Prev' : '← Previous Page',
      'swipe_up': '↑ Scroll Up',
      'swipe_down': '↓ Scroll Down',
      'peace': '✌️ Home',
      'thumbs_up': '👍 Scroll Up',
      'thumbs_down': '👎 Scroll Down',
      'point': '☝️ Toggle Card Mode',
      'rock_on': '🤘 Open / Select',
      'fist_hold': '✊ Pause Gestures'
    };
    return labels[gesture] || gesture;
  };

  if (!show || !enabled) return null;

  return (
    <div className="gesture-indicator">
      <div className="gesture-label">
        {getGestureLabel(gesture)}
      </div>
    </div>
  );
};

export default GestureIndicator;
